import React from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader } from './ModalComponent'
import { IoMdClose } from 'react-icons/io'
import { USER_ICON } from '../../../config/images'

const RecommendationDetail = ({ data, setData }) => {
    const onClose = () => {
        setData({
            open: false,
            data: null
        })
    }
    return (
        <Dialog open={data.open} onOpenChange={onClose}>
            <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className="max-w-xl">
                <DialogHeader>
                    <div className="flex justify-between items-center w-full border-b border-[#F1F5F9] px-4 py-4">
                        <h1 className="text-[#0F172A] text-lg font-bold">View Recommendation</h1>
                        <div
                            className="bg-[#F8FAFC] cursor-pointer w-10 h-10 rounded-lg flex justify-center items-center"
                            onClick={onClose}
                        >
                            <IoMdClose className="text-[#64748B]" />
                        </div>
                    </div>
                </DialogHeader>
                <DialogDescription className="">
                    <div className='px-6 pb-6 space-y-5 max-h-[500px] overflow-auto'>
                        <div className='flex flex-col space-y-2'>
                            <p className="text-sm font-semibold text-[#0F172A]">Photo</p>
                            <img
                                src={data?.data?.recommendation_img ? data?.data?.recommendation_img : USER_ICON}
                                alt="Profile"
                                className="w-32 h-32 rounded-full"
                            />
                        </div>
                        <div className='flex flex-col space-y-1'>
                            <p className="text-sm font-semibold text-[#0F172A]">Name</p>
                            <p className='text-wrap break-all'>{data?.data?.name ? data?.data?.name : "N/A"}</p>
                        </div>
                        <div className='flex flex-col space-y-1'>
                            <p className="text-sm font-semibold text-[#0F172A]">Link</p>
                            {data?.data?.link ? (
                                <a
                                    href={data.data.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className=" hover:underline break-all"
                                >
                                    {data.data.link}
                                </a>
                            ) : (
                                <p className='text-wrap break-all'>N/A</p>
                            )}
                        </div>
                        <div className='flex flex-col space-y-1'>
                            <p className="text-sm font-semibold text-[#0F172A]">Offers</p>
                            <p className='text-wrap break-all'>{data?.data?.offer ? data?.data?.offer : "N/A"}</p>
                        </div>
                        <div className='flex flex-col space-y-1'>
                            <p className="text-sm font-semibold text-[#0F172A]">Description</p>
                            <p className='text-wrap break-all'>{data?.data?.description ? data?.data?.description : "N/A"}</p>
                        </div>
                    </div>
                </DialogDescription>
            </DialogContent>
        </Dialog>
    )
}

export default RecommendationDetail